async function triggerLoanUpdateEmail(
  user,
  currentLoan,
  emailType, // welcome or update or intendToProceed,
  adminMessage,
  emailThreadData
) {
  const targetUrl = `${process.env.CMS_URL}/loans/sendloanupdateemail`;

  let resp;
  const token = await user.getIdToken();
  try {
    const res = await fetch(targetUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      //make sure to serialize your JSON body
      body: JSON.stringify({
        // these keys are case sensitive
        currentLoan,
        emailType,
        adminMessage,
        emailThreadData,
      }),
    });
    resp = await res.json();

    return resp;
  } catch (e) {
    console.log(e);
  }
}

export default triggerLoanUpdateEmail;
